import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setCampaign, clearCampaignsErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import Checkbox from 'material-ui/Checkbox';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
};

class CampaignNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: null,
        sentTo: null,
        emailSubject: null,
        emailFrom: null,
        source: null,
        template: null,
        emailReplyTo: null,
      },
      campaign: {
        name: '',
        salesChannelId: 1,
        sentTo: '',
        emailSubject: '',
        emailFrom: '',
        emailBcc: '',
        emailHeadline: '',
        emailBody: '',
        // source: localStorage.getItem('domain'),
        template: 'focus.default',
        emailReplyTo: '',
        logoImage: '',
        products: [],
        emailSubjectPromo:'',
        emailHeadlinePromo: '',
        emailBodyPromo: '',
        email2Subject:'',
        email2Headline: '',
        email2Body: '',
        email2SubjectPromo:'',
        email2HeadlinePromo: '',
        email2BodyPromo: '',
        email3Subject:'',
        email3Headline: '',
        email3Body: '',
        email3SubjectPromo:'',
        email3HeadlinePromo: '',
        email3BodyPromo: '',
        email4Subject:'',
        email4Headline: '',
        email4Body: '',
        email4SubjectPromo:'',
        email4HeadlinePromo: '',
        email4BodyPromo: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.campaign && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Campaign saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const campaign = this.state.campaign;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = campaign[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleDatePickerChange(e, date, target) {
    const campaign = this.state.campaign;
    campaign[target] = date;
    this.setState({
      campaign,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleSelectChange(event, index, value, t) {
    const campaign = this.state.campaign;
    if (Array.isArray(campaign[t])) {
      (campaign[t].includes(value)) ? _.pull(campaign[t], value) : campaign[t].push(value); // eslint-disable-line
    } else {
      campaign[t] = value;
    }
    this.setState({
      campaign,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChange(e) {
    const nextState = this.state.campaign;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      campaigns: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearCampaignsErrors());
    this.props.dispatch(setCampaign(this.state.campaign));
  }
  handleCancel() {
    this.props.dispatch(clearCampaignsErrors());
    browserHistory.push('/campaigns?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/campaigns?page=1');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
    };
    return (
      <div className="sales-channels component" style={authPage}>
        <h2>New Campaign</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.name || ''}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.name}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Logo Image"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.logoImage || ''}
            name="logoImage"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <br />
          <TextField
            floatingLabelText="Campaign Email"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.sentTo || ''}
            name="sentTo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.sentTo}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Email From"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailFrom || ''}
            name="emailFrom"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.emailFrom}
            errorStyle={{ color: cyan500 }}
          />
          <br />
          <TextField
            floatingLabelText="Email Reply To"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailReplyTo || ''}
            name="emailReplyTo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.emailReplyTo}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Email Bcc"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailBcc || ''}
            name="emailBcc"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <br />
          <br />
          <br />
          <ul>
            <li>
              <Checkbox
                label="Disabled"
                defaultChecked={this.state.campaign.disabled}
                name="disabled"
                onCheck={this.handleChange}
              />
            </li>
          </ul>
        </div>
        <h2>Trigger One</h2>
        <div className="content">
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailSubject || ''}
            name="emailSubject"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.emailSubject}
            errorStyle={{ color: cyan500 }}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailHeadline || ''}
            name="emailHeadline"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailBody || ''}
            name="emailBody"
            multiLine
            rows={3}
            onChange={this.handleChange}
            style={styles.textStyle}
          />
            </div>
          </div>
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailSubjectPromo || ''}
            name="emailSubjectPromo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            //errorText={this.state.required.emailSubject}
            errorStyle={{ color: cyan500 }}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailHeadlinePromo || ''}
            name="emailHeadlinePromo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.emailBodyPromo || ''}
            name="emailBodyPromo"
            multiLine
            rows={3}
            onChange={this.handleChange}
            style={styles.textStyle}
          />
            </div>
          </div>
          <br />  
        </div>
        <h2>Trigger Two</h2>
        <div className="content">
        <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email2Subject || ''}
            name="email2Subject"
            onChange={this.handleChange}
            style={styles.inputStyle}
            //errorText={this.state.required.emailSubject}
            errorStyle={{ color: cyan500 }}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email2Headline || ''}
            name="email2Headline"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email2Body || ''}
            name="email2Body"
            multiLine
            rows={3}
            onChange={this.handleChange}
            style={styles.textStyle}
          />
            </div>
          </div>
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email2SubjectPromo || ''}
            name="email2SubjectPromo"
            onChange={this.handleChange}
            style={styles.inputStyle}
           //errorText={this.state.required.emailSubject}
            errorStyle={{ color: cyan500 }}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email2HeadlinePromo || ''}
            name="email2HeadlinePromo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email2BodyPromo || ''}
            name="email2BodyPromo"
            multiLine
            rows={3}
            onChange={this.handleChange}
            style={styles.textStyle}
          />
            </div>
          </div>
        </div>
        <br/>
        <h2>Trigger Three</h2>
        <div className="content">
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email3Subject || ''}
            name="email3Subject"
            onChange={this.handleChange}
            style={styles.inputStyle}
            //errorText={this.state.required.emailSubject}
            errorStyle={{ color: cyan500 }}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email3Headline || ''}
            name="email3Headline"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email3Body || ''}
            name="email3Body"
            multiLine
            rows={3}
            onChange={this.handleChange}
            style={styles.textStyle}
          />
            </div>
          </div>
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email3SubjectPromo || ''}
            name="email3SubjectPromo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            //errorText={this.state.required.emailSubject}
            errorStyle={{ color: cyan500 }}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email3HeadlinePromo || ''}
            name="email3HeadlinePromo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email3BodyPromo || ''}
            name="email3BodyPromo"
            multiLine
            rows={3}
            onChange={this.handleChange}
            style={styles.textStyle}
          />
            </div>
          </div>
        </div>
        <br />
        <h2>Trigger Four</h2>
        <div className="content">
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email4Subject || ''}
            name="email4Subject"
            onChange={this.handleChange}
            style={styles.inputStyle}
            //errorText={this.state.required.emailSubject}
            errorStyle={{ color: cyan500 }}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email4Headline || ''}
            name="email4Headline"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email4Body || ''}
            name="email4Body"
            multiLine
            rows={3}
            onChange={this.handleChange}
            style={styles.textStyle}
          />
            </div>
          </div>
          <div className="row">
            <div className="col">
            <TextField
            floatingLabelText="Email Subject Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email4SubjectPromo || ''}
            name="email4SubjectPromo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            //errorText={this.state.required.emailSubject}
            errorStyle={{ color: cyan500 }}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Headline Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email4HeadlinePromo || ''}
            name="email4HeadlinePromo"
            onChange={this.handleChange}
            style={styles.inputStyle}
            multiLine
          />
            </div>
            <div className="col">
            <TextField
            floatingLabelText="Email Body Promo"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.campaign.email4BodyPromo || ''}
            name="email4BodyPromo"
            multiLine
            rows={3}
            onChange={this.handleChange}
            style={styles.textStyle}
          />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CampaignNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CampaignNewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    error: state.campaigns.error,
    campaign: state.campaigns.campaign,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(CampaignNewPage));



// WEBPACK FOOTER //
// ./src/containers/CampaignNewPage.js